import React, { useEffect, useState } from "react"
import { Modal } from "antd"
import PackageService from "src/services/PackageService" // Giả sử bạn đã định nghĩa API này trong service

const PackageDetailModal = ({ visible, onClose, packageData }) => {
  const [loading, setLoading] = useState(false)
  const [detailData, setDetailData] = useState(null)

  useEffect(() => {
    if (visible && packageData?.ID) {
      const fetchPackageDetail = async () => {
        setLoading(true)
        try {
          const response = await PackageService.packageDetailLeader(
            packageData.ID,
          )
          const data = response?.success || null
          setDetailData(data)
        } catch (error) {
          console.error("Failed to fetch package details:", error)
        } finally {
          setLoading(false)
        }
      }

      fetchPackageDetail()
    }
  }, [visible, packageData?.ID])

  if (!detailData) {
    return null // Nếu không có dữ liệu chi tiết, không render modal
  }

  return (
    <Modal
      title={detailData?.name || "Chi tiết gói cước"}
      open={visible}
      onCancel={onClose}
      footer={null}
      confirmLoading={loading}
    >
      <p>
        <strong>Nhà mạng:</strong> {detailData?.network?.name || "-"}
        {detailData?.country?.title && ` (${detailData?.country?.title})`}
      </p>
      <p>
        <strong>Nhà cung cấp:</strong> {detailData?.supplier?.name || "-"}
      </p>
      <p>
        <strong>Dung lượng DATA:</strong> {detailData?.data_quantity} GB
      </p>
      <p>
        <strong>Giá:</strong>{" "}
        {new Intl.NumberFormat().format(detailData?.price)}
      </p>
      <p>
        <strong>Mô tả:</strong>
        {[
          detailData?.daily_total && `Daily / ${detailData.daily_total}`,
          detailData?.data_quantity && `${detailData.data_quantity}GB`,
          detailData?.speed && `then ${detailData.speed}kbps`,
          detailData?.then_stop &&
            `${detailData.then_stop} / ${detailData?.date} ngày`,
        ]
          .filter(Boolean)
          .join(" ")}
      </p>
    </Modal>
  )
}

export default PackageDetailModal
